import api from './api';

export const bannerApi = {
  // Per-user feed (currently active + ack/minimize state for this user)
  // Pass locationId so location-scoped banners are filtered correctly.
  getActive: (locationId) =>
    api.get('/banners/active', { params: locationId ? { location_id: locationId } : {} }),

  // Pre-built templates
  getTemplates: () => api.get('/banners/templates'),

  // Admin listing — full history
  list: (params = {}) => api.get('/banners', { params }),

  create: (data) => api.post('/banners', data),
  update: (id, data) => api.put(`/banners/${id}`, data),
  remove: (id) => api.delete(`/banners/${id}`),

  // Per-user actions: minimize | expand | acknowledge
  ack: (id, action) => api.post(`/banners/${id}/ack`, { action }),
};

export default bannerApi;
